export const APP_NAME = 'Mola';
export const APP_DESCRIPTION = 'Dein Buchhaltungs Autopilot';
